module.exports = __webpack_public_path__ + "fonts/googleAuth@2x.2a0019440e7aebbf26268f5c0e907870.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/googleAuth@2x.png
// module id = 760
// module chunks = 9